<script lang="ts" setup>
import { useVModel } from '@vueuse/core';

interface Props {
	name?: string;
	modelValue: boolean;
}

const props = defineProps<Props>();

const emit = defineEmits<{
	(e: 'update:modelValue', v: boolean): void;
}>();

const checked = useVModel(props, 'modelValue', emit);
</script>

<template>
	<label class="base-checkbox">
		<input v-model="checked" :name="name" type="checkbox" class="base-checkbox__input" />

		<div class="base-checkbox__check" />

		<span class="base-checkbox__label">
			<slot />
		</span>
	</label>
</template>

<style lang="scss">
.base-checkbox {
	$size: 4.8rem;

	display: flex;
	align-items: center;

	&__input {
		display: none;
	}

	&__check {
		width: $size;
		height: $size;
		position: relative;
		border: 1px solid $color-dark;
		border-radius: 0.8rem;
	}

	&__label {
		margin-left: 1.6rem;
		font-size: $font-size-small;
	}

	&__input:checked ~ &__check {
		&::before {
			content: '';
			display: block;
			width: 1.2rem;
			height: 2.8rem;
			position: absolute;
			top: 0.5rem;
			left: 1.75rem;
			transform: rotate(45deg);
			border-right: 1px solid black;
			border-bottom: 1px solid black;
		}
	}
}
</style>
